// extracted by mini-css-extract-plugin
module.exports = {"input":"forms_input__1Jaau","label":"forms_label__2ywPJ"};